import { topSidePartOfWeb } from './parts/sideParts'

export const type7Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(300, 376) // 左下
  ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
  ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
  ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
  ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 左上方向
  ctx.moveTo(234, 265) // 左上
  ctx.quadraticCurveTo(250, 229, 250, 229) // 右上
  ctx.quadraticCurveTo(259, 289, 259, 289) // 右下
  ctx.quadraticCurveTo(249, 284, 249, 284) // 左下
  ctx.quadraticCurveTo(285, 222, 359, 146) // 右上
  // 右下方向
  ctx.moveTo(262, 200) // 左上
  ctx.quadraticCurveTo(349, 247, 349, 247) // 右下
  ctx.quadraticCurveTo(345, 274, 360, 279) // 左下
  // 左下方向
  ctx.moveTo(360, 154) // 左上
  ctx.quadraticCurveTo(307, 265, 287, 347) // 右下
  ctx.moveTo(277, 301) // 左上
  ctx.quadraticCurveTo(284, 342, 284, 342) // 右下
  ctx.moveTo(277, 301) // 左上
  ctx.quadraticCurveTo(320, 290, 341, 304) // 右下
  // 中の三角形
  ctx.moveTo(267, 225) // 頂点
  ctx.quadraticCurveTo(276, 286, 276, 286) // 左下
  ctx.quadraticCurveTo(305, 264, 330, 275) // 右下
  ctx.quadraticCurveTo(267, 225, 267, 225) // 頂点
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
}
